/* On-demand access to the existing Shopify Inbox UI. No chat messages are sent. */
(()=>{
 'use strict';
 if(window.__ttInboxOnDemand)return;
 window.__ttInboxOnDemand=true;
 const launchSelector='[data-site-chat]',seen=new WeakSet(),keyDocuments=new WeakSet(),chatFrames=new WeakSet();
 let host=null,runtime=null,returnTarget=null,lastOpen=false,pending=null,timer=0,frame=0,notice=null;
 const nativeRoot=()=>runtime?.shadowRoot||host?.shadowRoot;
 const activator=()=>nativeRoot()?.querySelector('[part~="activator"]');
 const isOpen=()=>!!(host?.hasAttribute('open')||runtime?.hasAttribute('open'));
 function onEscape(event){
  if(event.key!=='Escape'||event.defaultPrevented||!isOpen())return;
  const close=nativeRoot()?.querySelector('shopify-chat-icon-button.panel__close')?.shadowRoot?.querySelector('button');
  if(close){event.preventDefault();event.stopPropagation();close.click()}
 }
 function watchKeyboard(doc){if(!doc||keyDocuments.has(doc))return;keyDocuments.add(doc);doc.addEventListener('keydown',onEscape,true)}
 function watch(root,options){if(!root||seen.has(root))return;seen.add(root);new MutationObserver(schedule).observe(root,options)}
 function clearPending(){
  if(pending?.trigger)pending.trigger.removeAttribute('aria-busy');
  pending=null;clearTimeout(timer);timer=0;
 }
 function clearNotice(){if(notice){notice.remove();notice=null}}
 function showUnavailable(trigger){
  clearNotice();notice=document.createElement('div');notice.className='tt-chat-notice';
  const message=document.createElement('span');message.setAttribute('role','status');message.textContent='Chat couldn’t load. Please try again.';
  const retry=document.createElement('button');retry.type='button';retry.textContent='Retry';retry.addEventListener('click',()=>startChat(trigger));
  const close=document.createElement('button');close.type='button';close.className='tt-chat-notice-close';close.setAttribute('aria-label','Dismiss chat notice');close.textContent='×';close.addEventListener('click',clearNotice);
  notice.append(message,retry,close);document.body.append(notice);
 }
 function restoreFocus(){
  const usable=el=>el?.isConnected&&!el.closest('[hidden],[inert]')&&el.getClientRects().length;
  const target=[returnTarget,document.querySelector('.site-menu-toggle'),document.querySelector('.site-nav [data-menu="support"]'),document.querySelector('.site-brand')].find(usable);
  if(usable(target))requestAnimationFrame(()=>target.focus({preventScroll:true}));
 }
 function syncState(){
  const open=isOpen();
  for(const el of document.querySelectorAll(launchSelector))if(el.getAttribute('aria-expanded')!==String(open))el.setAttribute('aria-expanded',String(open));
  if(open===lastOpen)return;
  if(open&&!pending)returnTarget=activator()||returnTarget;
  lastOpen=open;
  document.dispatchEvent(new CustomEvent('site:chat',{detail:{open}}));
  if(!open){clearPending();restoreFocus()}
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(update)}
 function update(){
  frame=0;host=document.querySelector('shopify-chat');
  if(host){
   // The retired collision guard hid the whole widget. Never hide an open chat.
   if(host.hasAttribute('data-tt-inbox-hidden')){host.removeAttribute('data-tt-inbox-hidden');host.inert=false}
   watch(host,{attributes:true,attributeFilter:['open'],childList:true});
   watch(host.shadowRoot,{childList:true,subtree:true});
   runtime=host.shadowRoot?.querySelector('shopify-agent-runtime')||null;
   watch(runtime,{attributes:true,attributeFilter:['open'],childList:true});
   watch(runtime?.shadowRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['label','name','aria-expanded']});
   // Add Escape within the composer when its iframe permits same-origin
   // access. Cross-origin chat content retains Shopify’s native controls.
   for(const iframe of nativeRoot()?.querySelectorAll('iframe')||[]){
    const bind=()=>{try{watchKeyboard(iframe.contentDocument)}catch(_){}};
    bind();if(!chatFrames.has(iframe)){chatFrames.add(iframe);iframe.addEventListener('load',bind)}
   }
  }
  syncState();
  if(!pending)return;
  if(Date.now()>pending.deadline){
   const trigger=pending.trigger,opened=isOpen();clearPending();
   if(!opened)showUnavailable(trigger);
   return;
  }
  if(!isOpen()){
   const button=activator();
   // Use the same native control as “Need help?” when it is ready. A public
   // show() call made during mobile hydration can return without opening.
   const buttonReady=button&&!button.disabled&&button.getClientRects().length;
   if(buttonReady&&pending.clickedButton!==button){
    pending.clickedButton=button;pending.clickedAt=Date.now();button.click();
   }else if(host&&typeof host.show==='function'&&pending.openedHost!==host&&(!pending.clickedButton||Date.now()-pending.clickedAt>500)){
    pending.openedHost=host;
    try{host.show()}catch(_){/* Wait for the native activator to finish mounting. */}
   }
  }else{
   // Invoke Shopify's own expand control; do not rebuild or resize its iframe.
   const size=nativeRoot()?.querySelector('shopify-chat-icon-button.panel__size-toggle');
   const button=size?.shadowRoot?.querySelector('button');
   if(button&&size.getAttribute('name')==='size-expand')button.click();
   const dialog=nativeRoot()?.querySelector('[part~="dialog"]');
   // Mobile is already fullscreen and may not render a size control. Completion
   // depends on the native dialog, never on a desktop-only expand button.
   if(dialog){clearPending();clearNotice();dialog.focus({preventScroll:true})}
  }
  if(pending&&!timer)timer=setTimeout(()=>{timer=0;update()},100);
 }
 function startChat(trigger){
  returnTarget=trigger;clearPending();clearNotice();
  trigger.setAttribute('aria-busy','true');
  pending={trigger,clickedButton:null,clickedAt:0,openedHost:null,deadline:Date.now()+15000};
  document.dispatchEvent(new CustomEvent('site:close-menu'));
  update();
 }
 document.addEventListener('click',event=>{
  const trigger=event.target.closest?.(launchSelector);
  if(!trigger||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();startChat(trigger);
 },true);
 // Hide only the floating launcher until the hero has passed under the header.
 // A separate, lightweight scroll reader never runs the widget hydration loop.
 const hero=document.querySelector('tt-film-hero');
 if(hero){
  let heroFrame=0;
  const syncHeroLauncher=()=>{
   heroFrame=0;
   const bounds=hero.getBoundingClientRect();
   const headerBottom=document.querySelector('#site-header')?.getBoundingClientRect().bottom||0;
   document.body.classList.toggle('tt-hero-in-view',bounds.bottom>headerBottom+1&&bounds.top<window.innerHeight);
  };
  const scheduleHero=()=>{if(!heroFrame)heroFrame=requestAnimationFrame(syncHeroLauncher)};
  window.addEventListener('scroll',scheduleHero,{passive:true});
  window.addEventListener('resize',scheduleHero,{passive:true});
  window.addEventListener('pageshow',scheduleHero);
  if(typeof ResizeObserver!=='undefined')new ResizeObserver(scheduleHero).observe(hero);
  syncHeroLauncher();
 }
 watch(document.body,{childList:true,subtree:true});
 watchKeyboard(document);
 window.customElements?.whenDefined('shopify-chat').then(schedule);
 update();
})();
